import { BaseService } from '../base';

export type FireProtectionRatingType = {
  code: number;
  description: string;
};

export type FireProtectionRatingTypesMeta = {
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
};

export type FireProtectionRatingTypesResponse = {
  data: FireProtectionRatingType[];
  meta: FireProtectionRatingTypesMeta;
};

export class FireProtectionRatingTypesService extends BaseService {
  async getFireProtectionRatingTypes(): Promise<{
    success: boolean;
    data?: FireProtectionRatingTypesResponse;
    error?: string;
  }> {
    try {
      const path = `/portal/v1/products/fire-protection-rating-types`;
      const response = await this.get(path, {}, import.meta.env.VITE_API_URL);

      return await this.handleJsonResponse<FireProtectionRatingTypesResponse>(
        response
      );
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar sistemas de proteção contra incêndio',
      };
    }
  }
}

export const fireProtectionRatingTypesService =
  new FireProtectionRatingTypesService();
